import { render } from "./BetDetail.vue?vue&type=template&id=3af97f97&scoped=true"
import script from "./BetDetail.vue?vue&type=script&lang=js"
export * from "./BetDetail.vue?vue&type=script&lang=js"

import "./BetDetail.vue?vue&type=style&index=0&id=3af97f97&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af97f97"]])

export default __exports__